// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function iconClass(variant) {
  switch (variant) {
    case "Default" :
        return "bg-aliceblue text-verdigris";
    case "Warning" :
        return "bg-lemonchifon text-charcoal";
    case "Danger" :
        return "bg-red-100 text-firebrick";
    
  }
}

function confirmButtonClass(variant) {
  switch (variant) {
    case "Default" :
        return "bg-verdigris border-verdigris hover:opacity-90";
    case "Warning" :
        return "bg-cobalt border-cobalt hover:opacity-90";
    case "Danger" :
        return "bg-red-600 border-red-600 hover:bg-red-700";
    
  }
}

function ConfirmDialog(props) {
  var onConfirm = props.onConfirm;
  var onCancel = props.onCancel;
  var __confirming = props.confirming;
  var __variant = props.variant;
  var __cancelLabel = props.cancelLabel;
  var __confirmLabel = props.confirmLabel;
  var title = props.title;
  var confirmLabel = __confirmLabel !== undefined ? __confirmLabel : "Confirm";
  var cancelLabel = __cancelLabel !== undefined ? __cancelLabel : "Cancel";
  var variant = __variant !== undefined ? __variant : "Danger";
  var confirming = __confirming !== undefined ? __confirming : false;
  var tmp;
  switch (variant) {
    case "Default" :
        tmp = "ℹ️";
        break;
    case "Warning" :
        tmp = "⚠️";
        break;
    case "Danger" :
        tmp = "🗑️";
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      className: "fixed inset-0 bg-gray-600 bg-opacity-50",
                      onClick: (function (param) {
                          if (!confirming) {
                            return Curry._1(onCancel, undefined);
                          }
                          
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-4 w-4",
                                    alt: "",
                                    src: Image$ReactHooksTemplate.closeIcon
                                  }),
                              "aria-label": "Close",
                              className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed",
                              disabled: confirming,
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onCancel, undefined);
                                })
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("span", {
                                            children: tmp,
                                            className: "text-lg leading-none"
                                          }),
                                      className: "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 " + iconClass(variant)
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h2", {
                                              children: title,
                                              className: "text-lg font-semibold text-gray-900"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: props.message,
                                              className: "text-sm text-gray-600 mt-1 leading-relaxed"
                                            })
                                      ]
                                    })
                              ],
                              className: "flex items-start gap-3 mb-5 pr-6"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: cancelLabel,
                                      className: "px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition",
                                      disabled: confirming,
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(onCancel, undefined);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: confirming ? "Working..." : confirmLabel,
                                      className: "px-4 py-2 text-sm font-medium text-white rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition " + confirmButtonClass(variant),
                                      disabled: confirming,
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(onConfirm, undefined);
                                        })
                                    })
                              ],
                              className: "flex justify-end gap-3 border-t border-gray-200 pt-4"
                            })
                      ],
                      "aria-label": title,
                      "aria-modal": true,
                      className: "relative z-10 bg-white w-full max-w-md rounded-xl shadow-2xl border border-gray-200 p-6 overflow-hidden",
                      role: "alertdialog"
                    })
              ],
              className: "fixed inset-0 flex items-center justify-center p-4",
              style: {
                zIndex: "100"
              }
            });
}

var make = ConfirmDialog;

exports.make = make;
/* react/jsx-runtime Not a pure module */
